// src/redux/procsSlice.ts
// 工場・加工・機械のマスタデータ
import { createSlice } from "@reduxjs/toolkit";
import apiAxios from "../utils/apiAxios";
import { AnyAction, Dispatch } from "redux";
import { appendAlert } from "../redux/alertSlice";
import { GetProcs } from "../models/GetProcs";

type PlantProcMachList = {
  plantProcMach: GetProcs[];
};

// 初期値
const initialState: PlantProcMachList = {
  plantProcMach: [],
};

export const procsSlice = createSlice({
  name: "PlantProcMach",
  initialState,
  reducers: {
    setPlantProcMach: (state, { payload }) => {
      state.plantProcMach = payload;
    },
  },
});

const { setPlantProcMach } = procsSlice.actions;

// 工場・加工・機械の取得API
const fetchPlantProcMach = () => {
  return async (dispatch: Dispatch<AnyAction>) => {
    try {
      const response = await apiAxios.get<GetProcs>(`/procs`);
      const data = response.data;
      dispatch(setPlantProcMach(data));
    } catch (error: any) {
      console.error(error);
      dispatch(
        appendAlert({
          severity: "error",
          message: "データの取得に失敗しました。" + error.message,
          displayTime: 5000,
        })
      );
    }
  };
};

// 工場を指定して加工コード一覧を返すユーティリティ
const createProcOptions = (plant_code: string, plantProcMach: GetProcs[]) => {
  return plantProcMach
    .filter((item) => item.plant_code === plant_code)
    .map((item) => ({
      code: item.proc_code,
      name: item.proc_name,
    }));
};

// 工場コードと加工コードから機械作業コードのリストを返すユーティリティ
const createMachOptions = (
  plant_code: string,
  proc_code: string,
  plantProcMach: GetProcs[]
) => {
  const selectedPlantProcMach = plantProcMach.find(
    (item) => item.plant_code === plant_code && item.proc_code === proc_code
  );
  if (selectedPlantProcMach) {
    return selectedPlantProcMach.mach.map((mach) => ({
      code: mach.mach_op_code,
      name: mach.mach_name,
    }));
  } else {
    return [];
  }
};

export { fetchPlantProcMach, createProcOptions, createMachOptions };
export default procsSlice.reducer;
